var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentActivities({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 1.66602C18.0473 1.66602 19.1665 2.78531 19.1665 4.16602V5.83268H17.4999V15.8327C17.4999 17.2134 16.3806 18.3327 14.9999 18.3327H3.33319C1.95248 18.3327 0.833191 17.2134 0.833191 15.8327V14.166H14.1665V15.8327C14.1665 16.26 14.4882 16.6123 14.9027 16.6604L14.9999 16.666C15.4272 16.666 15.7794 16.3443 15.8276 15.9298L15.8332 15.8327V12.4993H2.49986V4.16602C2.49986 2.78531 3.61915 1.66602 4.99986 1.66602H16.6665Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentActivities);
export default __webpack_public_path__ + "static/media/assessment-activities.3d43f712115f38e1a315317bcea82a28.svg";
export { ForwardRef as ReactComponent };